import * as React from "react"
import { Redirect, Route, RouteComponentProps, RouteProps } from "react-router-dom"
import driverinfosecurity from "../../utils/DriverInfoSecurity";

type RouteComponent = React.FC<RouteComponentProps<{}>> | React.ComponentClass<any>

const AUTHENTICATED: boolean = driverinfosecurity.hasValidToken();

export const PrivateRoute: React.FC<RouteProps> = ({ component, ...rest }) => {
    const renderFn = (Component?: RouteComponent) => (props: RouteComponentProps<{}>) => {
        if (!Component) {
            return null
        }

        if (driverinfosecurity.hasValidToken()) {
            //console.log("Route evaluation is authenticated " + AUTHENTICATED);
            return <Component {...props as any} />
        }
        else {
        }

        const redirectProps = {
            to: {
                pathname: "/login",
                state: { from: props.location },
            },
        }

        return <Redirect {...redirectProps} />
    }

    //console.log("rendercomponent");
    return <Route {...rest} render={renderFn(component as RouteComponent)} />
}